import React , {Component} from 'react';
import NumberFormat from 'react-number-format';

class AddressCard extends Component{


    constructor(props){
        super(props)
        this.state = {
            delivery : 0
        }
    }

    handleSubmit(event){
        event.preventDefault()
        localStorage.setItem('selectedDelivery' , JSON.stringify(this.state.delivery))
        this.props.onAddressSelect()
    }

    componentWillMount() {
        this.setState({
            delivery : this.props.object
        })
        // console.log(this.props.mj)
    }

    render(){
        const {  object , showPrice } = this.props
        let priceText = (<div>
            هزینه پیک :  <NumberFormat value={object.price} displayType={'text'} thousandSeparator={true}  />   تومان
        </div>)


        if (parseInt(object.price) === 0)
            priceText = (
                <div> هزینه پیک : رایگان</div>
            )
        if (parseInt(object.price) === -1)
            priceText = (
                <div>خارج از محدوده سرویس</div>
            )

        const price = showPrice === true ? (
                <span className="price">
                {priceText}
            </span>
            ):
            (
                ``
            )

        return(
            <div className="address-card">
                <div className="content">
                    <div className="location">
                        {object.location}
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/location.svg" />
                    </div>
                    <div className="address-text">
                        {object.address}
                        <img className="icon" src="https://www.lavefood.com/webappassets/images/address.svg"  />
                    </div>
                </div>
                <footer className="footer">
                    <div className="b-row justify-content-between">
                        <div className="b-col-auto">
                            <div>
                                {price}
                            </div>
                        </div>
                        <div className="b-col-auto">
                            <form onSubmit={this.handleSubmit.bind(this)}>
                                <button className="btn select-address"  >
                                    انتخاب این آدرس
                                </button>
                            </form>
                        </div>
                    </div>
                </footer>
            </div>
        )
    }
}


export default AddressCard;